/* global webix */
import throttle from '../../vendor/lodash-es/throttle';

import i18n from './i18n/ru-RU';
import jqueryHelper from './jqueryHelper';
import datePcker from './datePicker';
import select from './select';

const link = document.createElement( 'link' );

link.rel = 'stylesheet';
link.href = '/js/vendor/webix/webix.css';
//document.getElementsByTagName( 'head' )[ 0 ].appendChild( link );

webix.ready( () => {
  i18n();
  jqueryHelper();
  //datePcker();
  //select();

  webix.i18n.setLocale( 'ru-RU' );

  // hide popup datepickers and selects on scroll
  const popups = document.querySelectorAll( '.popup' );
  [ ...popups ].forEach( ( popup ) => {
    popup.addEventListener( 'scroll',
      throttle( () => webix.callEvent( 'onClick', [] ), 50 )
    );
  } );
} );
